export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6384.07e7b9ec.jpg";